import { injectIntl } from "react-intl";
import { Button, Dialog, Typography, Grid } from "@mui/material";
import { getMessageString } from "../../utility";
import { AVVISO_UTENTE_DISABILITATO, CHIUDI } from "../../modules/language";

export const ModalInfoUser = injectIntl(({ intl, open, contenuto, onClose }) => {
  const d = new Date();
  let year = d.getFullYear();

  return (
    <>
      <Typography id={"modalConsensi_" + contenuto} sx={{ display: "none" }}>
        Modale avviso disabilitazione utente
      </Typography>
      <Dialog open={open} className="modalUser" aria-labelledby={"modalConsensi_" + contenuto}>
        <Grid container sx={{ padding: "5px" }}>
          <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
            {" "}
            <Typography sx={{ fontSize: "24px", fontWeight: "Bold" }}>
              {" "}
              A.S {year}/{year + 1}
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", padding: "10px" }}>
            {" "}
            <Typography sx={{ fontStyle: "italic" }}> {getMessageString(intl, AVVISO_UTENTE_DISABILITATO)}</Typography>
          </Grid>
          <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
            <Button variant="contained" onClick={onClose} className="chiudi">
              {getMessageString(intl, CHIUDI)}
            </Button>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
});
